import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("aaplus_cookie_consent")) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem("aaplus_cookie_consent", "accepted");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-[#1F2937] text-gray-200 border-t-4 border-[#FF5A00]" data-testid="cookie-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
        <p className="text-sm leading-relaxed max-w-3xl">
          Vi anvender kun nødvendige cookies, så hjemmesiden fungerer korrekt. Læs mere i vores{" "}
          <Link to="/cookiepolitik" className="text-[#FF5A00] underline hover:no-underline">cookiepolitik</Link>.
        </p>
        <button
          onClick={accept}
          data-testid="cookie-accept-btn"
          className="shrink-0 bg-[#FF5A00] text-white font-semibold text-sm px-6 py-2.5 rounded-sm hover:bg-[#E04F00] transition-colors"
        >
          Accepter
        </button>
      </div>
    </div>
  );
};
